import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-edit-btn',
    templateUrl: './edit-btn.component.html',
    styleUrls: ['./edit-btn.component.scss'],
    standalone: true,
    imports: []
})
export class EditBtnComponent implements ICellRendererAngularComp {
  params: any;
  editBtnVisible = false;

  constructor(public sharedService: SharedService) { }

  agInit(params: any): void {
    this.params = params;
    if (params.data['reservation_id'] || params.data['type'] || params.data['category'] || params.data['name'] || params.data['sales_receipt_number'] || params.data['contact']['display_name'] ) {
      this.editBtnVisible = true;
    }
  }
  refresh(params?: any): boolean {
    return true;
  }
  // Button functions
  editClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.editItemClick(rowData);
  }
}
